"use client";
import { useState } from "react";
import { Scrollama, Step } from "react-scrollama";
import StepMap from "./stepMap";
import StepHeadlines from "./stepHeadlines";
import End from "./end";
import StepBars from "./stepBars";
import StepCloud from "./stepCloud";

export function Scrolly() {
  const [currentStepIndex, setCurrentStepIndex] = useState(null);
  const [progress, setProgress] = useState({});
  // This callback fires when a Step hits the offset threshold. It receives the
  // data prop of the step, which in this demo stores the index of the step.
  const onStepEnter = ({ data }) => {
    setCurrentStepIndex(data);
  };

  return (
    <>
      <div style={{ border: "2px dashed skyblue" }}>
        <div className="text-black w-full flex -z-10 !sticky top-0 ">
          <div className="relative w-full">
            <div
              className="w-1/2 h-screen absolute "
              style={{
                backgroundImage: 'url("/images/mixed-feelings/bg-left.png")',
                backgroundPosition: "center",
              }}
            />
            <div
              className="w-1/2 h-screen absolute  left-1/2"
              style={{
                backgroundImage: 'url("/images/mixed-feelings/bg-right.png")',
                backgroundPosition: "center",
              }}
            />
          </div>
        </div>
        <Scrollama
          offset={0.9}
          onStepEnter={onStepEnter}
          onStepProgress={(e) => {
            setProgress(e);
          }}
        >
          <Step data={1}>
            <div className="h-[400vh] max-w-[1440px] mx-auto -mt-16 relative overflow-visible">
              <StepHeadlines
                stepNumber={1}
                currentStepIndex={currentStepIndex}
                progress={progress}
              />
            </div>
          </Step>
          <Step data={2}>
            <div className="h-screen w-full "></div>
          </Step>
          <Step data={3}>
            <div className="h-screen w-full "></div>
          </Step>
          <Step data={4}>
            <div className="h-96">
              <StepMap
                stepNumber={4}
                currentStepIndex={currentStepIndex}
                progress={progress}
              />
            </div>
          </Step>
          <Step data={5}>
            <div className="h-96 w-full "></div>
          </Step>
          <Step data={6}>
            <div className="h-screen w-full "></div>
          </Step>
          <Step data={7}>
            <div className="h-96 w-full "></div>
          </Step>
          <Step data={8}>
            <div className="h-96 w-full "></div>
          </Step>
          <Step data={9}>
            <div className="h-96 w-full "></div>
          </Step>
          <Step data={10}>
            <div className="h-screen w-full "></div>
          </Step>
          <Step data={11}>
            <div className="h-96 w-full "></div>
          </Step>
          <Step data={12}>
            <div className="h-screen w-full "></div>
          </Step>
          <Step data={13}>
            <div className="h-[50vh] w-full"></div>
          </Step>
          <Step data={14}>
            <div className="h-[300vh] w-full">
              <StepBars
                stepNumber={14}
                currentStepIndex={currentStepIndex}
                progress={progress}
              />
            </div>
          </Step>
          <Step data={15}>
            <div className="mt-[60vh] h-[150vh] md:h-[200vh]  w-full">
              <StepCloud
                stepNumber={15}
                currentStepIndex={currentStepIndex}
                progress={progress}
              />
            </div>
          </Step>
          <Step data={16}>
            <div className="bg-white h-screen">
              <End
                progress={progress}
                stepNumber={16}
                currentStepIndex={currentStepIndex}
              />
            </div>
          </Step>
        </Scrollama>{" "}
      </div>
    </>
  );
}
